export default __webpack_public_path__ + "static/media/highlight-1-new.dbca15c6.png";